// File: src/pages/order_menuitems.js

import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { notifyUser } from "../utils/notifyUser";

function OrderMenuItems() {
    const [sections, setSections] = useState([]);
    const [selectedRole] = useState("");
    const currentUser = localStorage.getItem("user") || "admin";

    // Fetch sections from the master API on initial load
    useEffect(() => {
        fetchSectionsOnly();
    }, []);

    // Fetch menu items based on the selected role
    useEffect(() => {
        if(selectedRole) {
            fetchMenuByRole(selectedRole);
        }
    }, [selectedRole]);

    // Fetch sections from the master API
    const fetchSectionsOnly = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/menu/master`,
                { withCredentials: true },
            );

            // Filter only sections
            const sectionItems = response.data.filter(
                (item) => item.item_type === "section",
            );

            // Sort by existing order_index
            sectionItems.sort((a, b) => a.order_index - b.order_index);

            setSections(sectionItems);
            console.log("Fetched sections from master API:", sectionItems);
        } catch(error) {
            console.error("Error fetching sections:", error.message);
            notifyUser(null, "error", "Error fetching sections.", "toast", null, null, null, null, null, false, false, "top-center");
        }
    };

    // Fetch menu items by role
    const fetchMenuByRole = async (role) => {
        const url = `${process.env.REACT_APP_BACKEND_URL}/api/menu/by-role/${role}`;
        console.log(`Fetching menu from URL: ${url}`);

        try {
            const response = await axios.get(url, { withCredentials: true });
            const menuItems = response.data;

            console.log(`Fetched menu items for role ${role}:`, menuItems);

            // Sort by order_index
            menuItems.sort((a, b) => a.order_index - b.order_index);

            setSections(menuItems);
        } catch(error) {
            console.error(
                `Error fetching menu for role ${role}:`,
                error.message,
            );
            notifyUser(null, "error", `Error fetching menu for role ${role}.`, "toast", null, null, null, null, null, false, false, "top-center");
        }
    };

    const moveUp = (index) => {
        if(index > 0) {
            const updatedSections = [...sections];
            [updatedSections[index], updatedSections[index - 1]] = [
                updatedSections[index - 1],
                updatedSections[index],
            ];
            setSections(updatedSections);
        }
    };

    const moveDown = (index) => {
        if(index < sections.length - 1) {
            const updatedSections = [...sections];
            [updatedSections[index], updatedSections[index + 1]] = [
                updatedSections[index + 1],
                updatedSections[index],
            ];
            setSections(updatedSections);
        }
    };

    const handleOrderChange = (index, value) => {
        const updatedSections = [...sections];
        updatedSections[index].order_index = parseInt(value, 10) || 0;
        setSections(updatedSections);
    };

    const saveSectionOrder = async () => {
        try {
            const payload = {
                user: currentUser,
                menuUpdates: sections.map((item, index) => ({
                    id: item.id,
                    parent_id: null,
                    order_index: index + 1,
                })),
            };

            console.log(`Saving section order with payload:`, payload);

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/menu/bulk-update-order`,
                payload,
                { withCredentials: true },
            );

            if(response.data.success) {
                console.log("Section order saved successfully.");
                if(selectedRole) {
                    fetchMenuByRole(selectedRole);
                } else {
                    fetchSectionsOnly();
                }
                notifyUser(null, "success", "Section order updated successfully!", "toast", null, null, null, null, null, false, false, "top-center");
            } else {
                console.error("Failed to update section order.");
                notifyUser(null, "error", "Failed to update section order.", "toast", null, null, null, null, null, false, false, "top-center");
            }
        } catch(error) {
            console.error("Error saving section order:", error.message);
            notifyUser(null, "error", "Error saving section order.", "toast", null, null, null, null, null, false, false, "top-center");
        }
    };

    return (
        <div className="p-10  bg-white">
            {/* Page Heading */}
            <div className="mt-10 mb-8 flex items-center justify-between">
                <h2
                    style={{
                        color: "#333333",
                        marginRight: "20px",
                        fontSize: "x-large",
                        fontFamily: "large",
                    }}
                >
                    ORDER SECTIONS
                </h2>

                {/* Role Dropdown */}
                {/* <select
                    value={selectedRole}
                    onChange={(e) => {
                        console.log(`Role changed to: ${e.target.value}`); // Debug: Log role change
                        setSelectedRole(e.target.value);
                    }}
                    className="border rounded p-2"
                >
                    <option value="">Select Role</option>
                    <option value="investor">Investor</option>
                    <option value="entrepreneur">Entrepreneur</option>
                </select> */}
            </div>

            {/* Section Reordering Cards */}
            <div className="border rounded shadow-lg p-6 bg-white space-y-5">
                {sections.length === 0 ? (
                    <p className="text-gray-500">Loading sections...</p>
                ) : (
                    <div className="space-y-5">
                        {sections.map((section, index) => (
                            <div
                                key={section.id}
                                className="flex justify-between items-center border p-4 rounded hover:shadow-md transition-all bg-gray-50"
                            >
                                {/* Section Title */}
                                <div className="flex flex-col">
                                    <span className="font-semibold text-gray-800">
                                        {section.title}
                                    </span>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex items-center space-x-3">
                                    <button
                                        onClick={() => moveUp(index)}
                                        className="text-black-600 hover:text-black-800"
                                        title="Move Up"
                                    >
                                        <FaArrowUp size={18} />
                                    </button>

                                    <button
                                        onClick={() => moveDown(index)}
                                        className="text-black-600 hover:text-black-800"
                                        title="Move Down"
                                    >
                                        <FaArrowDown size={18} />
                                    </button>

                                    <input
                                        type="number"
                                        value={section.order_index}
                                        onChange={(e) =>
                                            handleOrderChange(
                                                index,
                                                e.target.value,
                                            )
                                        }
                                        className="border rounded p-1 w-16 text-center"
                                        min="0"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Save Button */}
            <div className="mt-10 flex justify-center">
                <button
                    onClick={saveSectionOrder}
                    className="aqi-primary-action rounded bg-navy px-8 py-3 font-bold text-white shadow-md hover:bg-[#003954]"
                >
                    Save Section Order
                </button>
            </div>
        </div>
    );
}

export default OrderMenuItems;
